/* eslint-disable react-hooks/exhaustive-deps */
import classNames from 'classnames';
import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import React, { useContext, useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { DEFAULT_LOCATION } from '../../brands/default/config';
import { MODALS } from '../../brands/default/constants';
import { LIGHTBOX_MODAL_VARIANT_TWO } from '../../brands/default/features';
import { getLocationFromUrl } from '../../helpers/metadata';
import { pathLocationInfo } from '../../helpers/url';
import ThemeContext from '../../providers/ThemeProvider';
import WowModal from '../WowModal';
import SubscribeModalBackground from './SubscribeModalBackground';
import { Subscriber } from './Subscriber';

const SubscribeModal = ({
  showModal,
  isBadConnection,
  showCloseIcon,
  setShowModal,
  isLightBox,
  showWhenAuthenticated,
  list,
}) => {
  const theme = useContext(ThemeContext);
  const router = useRouter();
  const path = router.asPath;

  const filteredList = list.filter(
    (locat) => locat.countryCode === process.env.NEXT_PUBLIC_COUNTRY_CODE,
  );

  const locationFromURL = getLocationFromUrl(router.asPath, filteredList);

  const [locationAux, setSelectLocation] = useState(
    locationFromURL?.shortName || DEFAULT_LOCATION.shortName,
  );

  const [location, locations] = useSelector((state) => [
    state.locations.location,
    state.locations.locations,
  ]);
  const [isAuthenticated] = useSelector((state) => [
    state.user.isAuthenticated,
  ]);

  const { isLocationPage } = pathLocationInfo(path, locations);

  useEffect(() => {
    // Update select default with the value in redux
    if (location && location.shortName && location.shortName !== locationAux) {
      setSelectLocation(location.shortName);
    }
  }, [location]);

  useEffect(() => {
    window?._satellite?.track('lightbox_appear');
  }, []);

  const modalExtraClasses = classNames(
    `lightbox-modal remove-header with-animation no-body-padding fullscreen-mobile`,
    {
      'lightbox-modal--light': isBadConnection,
      'lightbox-modal--ls': LIGHTBOX_MODAL_VARIANT_TWO,
      'lightbox-modal--standart': !isBadConnection,
    },
  );

  if ((isAuthenticated && !showWhenAuthenticated) || list.length < 1)
    return null;

  return (
    <WowModal
      ariaLabelledBy="id-subscribe-modal"
      backdrop="static"
      backdropClassName="over-backdrop9999"
      centered
      defaultLocation={location}
      dialogId={MODALS.lightbox}
      extraClasses={modalExtraClasses}
      setShowModal={setShowModal}
      showModal={showModal}
      size="sm"
    >
      {!isBadConnection && <SubscribeModalBackground />}
      <div
        className={classNames('popeye-modal', {
          'popeye-modal--light': isLightBox && isBadConnection,
          'popeye-modal--standart': isLightBox && !isBadConnection,
        })}
      >
        <Subscriber
          defaultLocation={locationAux}
          isAuthenticated={isAuthenticated}
          isBadConnection={isBadConnection}
          isLightBox
          isLocation={isLocationPage}
          list={filteredList}
          setShowModal={setShowModal}
          showCloseIcon={showCloseIcon}
        />
      </div>

      <style jsx>{`
        .popeye-modal {
          padding: 20px;
        }
        .popeye-modal--standart {
          position: relative;
          z-index: 1;
        }
        .popeye-modal--light {
          background: white;
        }
        :global(.lightbox-modal--ls .popeye-modal--light .both .headerlogo) {
          display: block;
        }
        :global(
            .lightbox-modal--ls .popeye-modal--light .both .headerlogoreversed
          ) {
          display: none;
        }
        @media (min-width: ${theme.breakpoints.smUp}) {
          //576px
          .popeye-modal--light {
            background: transparent;
          }
        }
        @media (min-width: ${theme.breakpoints.mdUp}) {
          .popeye-modal {
            padding: 0;
          }
          .popeye-modal--light {
            margin: 0 auto;
          }
          .popeye-modal--standart {
            display: flex;
            justify-content: flex-end;
            padding: 10px;
          }
        }
      `}</style>
      <style global jsx>{`
        .modal.lightbox-modal .modal-content {
          height: 100%;
        }
        .modal.lightbox-modal .login-modal {
          margin-right: 30px;
        }
        .modal.lightbox-modal .login-modal--close {
          margin-right: 0;
        }
        .modal.lightbox-modal,
        .over-backdrop9999 {
          z-index: 9999;
        }
        .subscribe-form__google-sign-in-container a.media-button.google {
          width: 100%;
          border-radius: 3px;
          box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.15);
        }
        .subscribe-form__google-sign-in-container a.media-button.google:hover {
          box-shadow: 5px 5px 4px 0 rgba(0, 0, 0, 0.4);
        }
        .subscribe-form__google-sign-in-container
          a.media-button.google
          .media-button__text {
          font-size: 16px;
        }

        @media (min-width: ${theme.breakpoints.smUp}) {
          //576px
          .modal.lightbox-modal--standart .modal-sm {
            width: 90%;
            max-width: 920px;
          }

          .modal.lightbox-modal--light .modal-sm {
            width: 90%;
            max-width: 450px;
          }
        }
        @media (min-width: ${theme.breakpoints.mdUp}) {
          //768
          .modal.lightbox-modal .modal-content {
            background-color: transparent;
          }
          .modal.lightbox-modal--light .modal-sm .subscriber-wrapper {
            margin: 0 auto;
            max-width: 450px;
          }
        }
        // Can be removed when WowModal is mobile first
        @media (width: ${theme.breakpoints.mdUp}) {
          .popeye-modal {
            width: 100%;
            height: 100%;
          }
          .modal.lightbox-modal .modal-content {
            height: auto;
          }
        }
      `}</style>
    </WowModal>
  );
};

SubscribeModal.propTypes = {
  isBadConnection: PropTypes.bool,
  isLightBox: PropTypes.bool,
  list: PropTypes.array.isRequired,
  setShowModal: PropTypes.func,
  showCloseIcon: PropTypes.bool,
  showModal: PropTypes.bool,
  showWhenAuthenticated: PropTypes.bool,
};

SubscribeModal.defaultProps = {
  isBadConnection: true,
  isLightBox: false,
  setShowModal: () => {},
  showCloseIcon: false,
  showModal: false,
  showWhenAuthenticated: false,
};

export default SubscribeModal;
